import { Component, OnInit, Input } from '@angular/core';
import { ConfirmDialogComponent } from 'src/app/services/dialog/confirm-dialog/confirm-dialog.component';
import { DialogService, LanguageService, HelperService, AuthService } from 'src/app/services';
import { AllocationService } from 'src/app/pages/allocation/allocation.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { AllocFilterComponent } from './alloc-filter/alloc-filter.component';
import { ConstantsHelper } from 'src/assets/constants/constants.helper';
import { environment } from 'src/environments/environment';
import { MediaObserver } from '@angular/flex-layout';
import { catchError, finalize } from 'rxjs/operators';
import { of as observableOf, forkJoin } from 'rxjs';
import { MatDialogRef } from '@angular/material/dialog';
import { requestUserAllocationDownload, requestRecipientAllocationDownload } from 'src/app/model/requests';
import * as moment from 'moment';
import * as XLSX from 'xlsx';
import * as _ from 'lodash';

@Component({
  selector: 'esc-allocation',
  templateUrl: './allocation.component.html',
  styleUrls: ['./allocation.component.scss']
})
export class AllocationComponent implements OnInit {
  @Input() displayRecipientGroup;
  @Input() displayAllocatedQty;
  @Input() displayWebUser;
  @Input() allocationLevel;
  @Input() moduleCode;

  public loading = {
    init: false,
    allocate: false,
    export: false,
    import: false,
    error: false,
  };
  filterNumber;
  concurrentRequests = [];
  public formGroup: FormGroup;
  public listData = [];
  quantity = [];
  hideDetails = false;
  qtySumTotal = 0;
  currentFilter = {};
  networkErrMsg = this.languageService.getTranslation("MSG_ERROR_NETWORK_CONNECTION", {});
  displayedColumns: string[] = ['username', 'fullname', 'group_filter', 'quantity', 'allocated_quantity'];
  public constants = ConstantsHelper;

  constructor(
    private fb: FormBuilder,
    public media: MediaObserver,
    private helper: HelperService,
    public authService: AuthService,
    private allocSvc: AllocationService,
    private dialogService: DialogService,
    private languageService: LanguageService,
  ) { }

  ngOnInit() {
    this.initForm();
    this.setDisplayedColumns();
    setTimeout(() => {
      this.openFilter();
    }, 100);
  }

  initForm() {
    this.formGroup = this.fb.group({
      campaign_code: null,
      campaign_description: null,
      distribution_code: null,
      distribution_description: null,
      from_series: null,
      to_series: null,
      series: null,
      total_quantity: null,
      available_quantity: null,
      allocated_qty: null,
    });
 
    this.formGroup.disable();
  }

  setDisplayedColumns() {
    if(this.allocationLevel == 'one') {
      this.displayedColumns = this.displayedColumns.filter(e => {
        return e != 'fullname'
      })
    } else {
      this.displayedColumns = this.displayedColumns.filter(e => {
        return e != 'username'
      })
    }
  }

  openFilter() {
    let dialogRef: MatDialogRef<AllocFilterComponent>;
    let dataObj = Object.assign(_.get(this, 'currentFilter'), { allocationLevel : this.allocationLevel });

    dialogRef = this.dialogService.openDialog(AllocFilterComponent, {
      width: '500px',
      // height: this.media.isActive('lt-sm') ? '300px' : (this.displayRecipientGroup && this.helper.isUserAdmin()) ? '50%' : '40%',
      autoFocus: false,
      data: dataObj
    });
    dialogRef.afterClosed().subscribe((filter) => {
      if (filter) {
        if(environment.showLogs) {
          console.log("filter", filter);
        }
        this.currentFilter = _.cloneDeep(filter);
        this.concurrentRequests = [];
        this.listData = [];

        this.concurrentRequests.push(this.allocSvc.getDistributionCouponDetail(this.allocationLevel,{
          web_filter: {
            distribution_id: _.get(filter.selectedCampaign, 'distribution_id'),
            user_id: _.get(filter.selectedWebUser, 'user_id') || localStorage.getItem("userId")
          }
        }));

        this.concurrentRequests.push(this.allocSvc.getUserList(
          this.allocationLevel,
          {
            web_filter: {
              group_filter_ids: _.get(filter, 'selectedGroup').map(e => {
                return e.id;
              }),
              user_id: _.get(filter.selectedWebUser, 'user_id') || localStorage.getItem("userId"),
              distribution_id: _.get(filter.selectedCampaign, 'distribution_id')
            }
          }));
        this.getDetails();
        this.quantity = [];
      }
    });
  }

  getDetails() {
    let loadingDialog = this.dialogService.loading();
    this.formGroup.reset();
    forkJoin(...this.concurrentRequests).pipe(
      finalize (() => {
        loadingDialog.close();
        return observableOf(null);
      })
    )
    .subscribe(res => {
      if(environment.showLogs) {
        console.log(res);
      }
      let tempData = res.map(e => {
        return e;
      })

      // console.log('temp_data');

      this.formGroup.get('campaign_code').setValue(_.get(this.currentFilter['selectedCampaign'], 'campaign_code'));
      this.formGroup.get('campaign_description').setValue(_.get(this.currentFilter['selectedCampaign'], 'campaign_description'));
      this.formGroup.get('distribution_code').setValue(_.get(this.currentFilter['selectedCampaign'], 'distribution_code'));
      this.formGroup.get('distribution_description').setValue(_.get(this.currentFilter['selectedCampaign'], 'distribution_description'));

      let data0 = _.get(tempData[0],'data');
      let data1 = _.get(tempData[1],'data');

      if(_.has(data0, 'from_series')) {
        this.formGroup.get('from_series').setValue(_.get(data0, 'from_series'));
        this.formGroup.get('to_series').setValue(_.get(data0, 'to_series'));
        this.formGroup.get('total_quantity').setValue(_.get(data0, 'total_quantity'));
        this.formGroup.get('available_quantity').setValue(_.get(data0, 'available_quantity'));
        this.formGroup.get('allocated_qty').setValue(_.get(data0, 'allocated_quantity'));
        this.listData = this.listData.concat(data1);
      } 
      else if(_.has(data1, 'from_series')){
        this.formGroup.get('from_series').setValue(_.get(data1, 'from_series'));
        this.formGroup.get('to_series').setValue(_.get(data1, 'to_series'));
        this.formGroup.get('total_quantity').setValue(_.get(data1, 'total_quantity'));
        this.formGroup.get('available_quantity').setValue(_.get(data1, 'available_quantity'));
        this.formGroup.get('allocated_qty').setValue(_.get(data0, 'allocated_quantity'));
        this.listData = this.listData.concat(data0);
      }
      else if(_.has(data0, 'series')) {
        this.formGroup.get('series').setValue(_.get(data0, 'series'));
        this.formGroup.get('total_quantity').setValue(_.get(data0, 'total_quantity'));
        this.formGroup.get('available_quantity').setValue(_.get(data0, 'available_quantity'));  
        this.formGroup.get('allocated_qty').setValue(_.get(data0, 'allocated_quantity'));
        this.listData = this.listData.concat(data1);
      } 
      else if(_.has(data1, 'series')){
        this.formGroup.get('series').setValue(_.get(data1, 'series'));
        this.formGroup.get('total_quantity').setValue(_.get(data1, 'total_quantity'));
        this.formGroup.get('available_quantity').setValue(_.get(data1, 'available_quantity'));  
        this.formGroup.get('allocated_qty').setValue(_.get(data1, 'allocated_quantity'));
        this.listData = this.listData.concat(data0);
      }
      else {
        this.dialogService.openSnackBar(this.networkErrMsg);
      }
    }, err => {
      if(environment.showLogs) {
        console.log(err);
      }
      this.dialogService.openSnackBar("ERROR: ", err);
    })
  }
  
  quantityChanged(rowData, quantity, idx) {
    if((!quantity || (quantity < 1)) && rowData['series']) {
      this.dialogService.openDialog(ConfirmDialogComponent, {
        width: "400px",
        autoFocus: true,
        disableClose: true,
        data: {
          title: this.languageService.getTranslation("MSG_CONFIRM_ACTION", {}),
          message: this.languageService.getTranslation("MSG_ALLOC_CLEAR_QTY", {}),
          button: this.languageService.getTranslation("LABEL_YES", {}),
          cancelButton: this.languageService.getTranslation("LABEL_NO", {}),
        }
      })
      .afterClosed()
      .subscribe(result => {
        if(result) {
          delete rowData['series'];
          delete rowData['quantity'];
          rowData["distribution_id"] = _.get(this.currentFilter["selectedCampaign"], 'distribution_id');
          if(this.allocationLevel == 'two') {
            rowData['user_id'] = _.get(this.currentFilter["selectedWebUser"], 'user_id') || localStorage.getItem("userId");
          }
        }
        else {
          console.log(this.quantity, idx, "STILL WORKING ON THIS")
        }
      })
    } 
    else {
      // rowData["quantity"] = parseInt(_.cloneDeep(quantity));
      rowData["quantity"] = _.cloneDeep(quantity);
      rowData["distribution_id"] = _.get(this.currentFilter["selectedCampaign"], 'distribution_id');
      if(this.allocationLevel == 'two') {
        rowData['user_id'] = _.get(this.currentFilter["selectedWebUser"], 'user_id') || localStorage.getItem("userId");
      }
    }
  }

  validateInputQuantity() {
    this.qtySumTotal = 0;
    this.listData.forEach(e => {
      this.qtySumTotal += parseInt(_.get(e, 'quantity')) || 0;
    });

    if(this.qtySumTotal <= _.get(this.formGroup.get('available_quantity'), 'value')) {
      this.confirmAllocation();
    } else {
      this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_ALLOC_CANT_EXCEED", {}) + _.get(this.formGroup.get('available_quantity'), 'value') + this.languageService.getTranslation("MSG_ALLOC_CHANGE", {}));
    }
  }

  confirmAllocation() {
    let reqObj = {};
    
    reqObj["data"] = this.listData.filter(e => {
      return (e.quantity) && (e.quantity > 0) && (e.quantity != null);
    }).map(f => {
      let temp = {
        distribution_id: f.distribution_id,
        // user_id: this.helper.isUserAdmin() ? parseInt(localStorage.getItem("userId")) : parseInt(f.user_id),
        user_id: parseInt(f.user_id),
        quantity: parseInt(f.quantity)
      }
      if(this.allocationLevel == 'two') {
        temp['recipient_id'] = f.recipient_id;
      }
      
      return temp;
    });

    this.dialogService.openDialog(ConfirmDialogComponent, {
      width: "400px",
      autoFocus: true,
      disableClose: true,
      data: {
        title: this.languageService.getTranslation("MSG_CONFIRM_ACTION", {}),
        message: this.languageService.getTranslation("MSG_ALLOC_TO", {}) + reqObj["data"].length + this.languageService.getTranslation("MSG_ALLOC_USERS", {}),
        button: this.languageService.getTranslation("LABEL_YES", {}),
        cancelButton: this.languageService.getTranslation("LABEL_NO", {}),
      }
    })
    .afterClosed()
    .subscribe(result => {
      if(result) {
        if(this.allocationLevel == "one") {
          this.validateLevelOneQuantity(reqObj);
        } else {
          this.validateLevelTwoQuantity(reqObj);
        }
      }
    })
  }

  validateLevelOneQuantity(data) {
    let loadingDialog = this.dialogService.loading();
    let reqObj = {
      web_filter: {
        distribution_id: _.get(this.currentFilter["selectedCampaign"], 'distribution_id'),
        total_allocated_quantity: this.qtySumTotal
      }
    }
    this.allocSvc.validateLevelOne(reqObj).pipe(
    finalize(() => {
      loadingDialog.close();
      return observableOf(null);
    }))
    .subscribe((res: any) => {
      if (environment.showLogs) {
        console.log(res);
      }
      if (_.toLower(_.get(res, 'value')) == 'success') {
        this.allocateLevelOne(data);
      }
      else {
        this.dialogService.openSnackBar(this.networkErrMsg);
      }
    }, err => {
      console.log(err);
    });
  }

  allocateLevelOne(data) {
    let loadingDialog = this.dialogService.loading();
    this.allocSvc.allocateLevelOne(data).pipe(
    finalize(() => {
      loadingDialog.close();
      return observableOf(null);
    }))
    .subscribe((res: any) => {
      if (environment.showLogs) {
        console.log(res);
      }
      if (_.get(res, 'success.count') > 0) {
        this.allocationSuccessDialog();
      }
      else {
        this.dialogService.openSnackBar(this.networkErrMsg);
      }
    },
    err => {
      console.log(err);
    });
  }

  validateLevelTwoQuantity(data) {
    let loadingDialog = this.dialogService.loading();
    let reqObj = {
      web_filter: {
        distribution_id: _.get(this.currentFilter["selectedCampaign"], 'distribution_id'),
        user_id: _.get(this.currentFilter["selectedWebUser"], 'user_id') || localStorage.getItem("userId"),
        total_allocated_quantity: this.qtySumTotal
      }
    }
    this.allocSvc.validateLevelTwo(reqObj).pipe(
    finalize(() => {
      loadingDialog.close();
      return observableOf(null);
    }))
    .subscribe((res: any) => {
      if (environment.showLogs) {
        console.log(res);
      }
      if (_.toLower(_.get(res, 'value')) == 'success') {
        this.allocateLevelTwo(data);
      }
      else {
        this.dialogService.openSnackBar(this.networkErrMsg);
      }
    },
    err => {
      console.log(err);
    });
  }

  allocateLevelTwo(data) {
    let loadingDialog = this.dialogService.loading();
    this.allocSvc.allocateLevelTwo(data).pipe(
      finalize(() => {
        loadingDialog.close();
        return observableOf(null);
      })
    )
    .subscribe(
      (res: any) => {
        if (environment.showLogs) {
          console.log(res);
        }
        loadingDialog.close();
        if (_.get(res, 'success.count') > 0) {
          this.allocationSuccessDialog();
        }
        else {
          this.dialogService.openSnackBar(this.networkErrMsg);
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  private allocationSuccessDialog() {
    const title = this.allocationLevel == "two" ? "MODULE_ALLOCATION_LV2" : "MODULE_ALLOCATION_LV1";
    const message = this.allocationLevel == "two" ? "MSG_SUCCESS_EMAIL_LEVEL_TWO_ALLOCATION" : "MSG_SUCCESS_EMAIL_LEVEL_ONE_ALLOCATION";

    this.dialogService.openDialog(ConfirmDialogComponent, {
      width: "400px",
      autoFocus: true,
      disableClose: true,
      data: {
        title: this.languageService.getTranslation(title, {}),
        message: this.languageService.getTranslation(message, {}),
        button: this.languageService.getTranslation("LABEL_OK", {}),
        hasCancel: false,
      }
    })
    .afterClosed()
    .subscribe(result => {
      this.reloadAndClear(false);
    });
  }

  autoDownload(data) {
    let loadingDialog = this.dialogService.loading();

    let txnNumArr = data.map(e => {
      return _.get(e.details.object, 'transaction_number');
    });
    let arr = [];
    txnNumArr.forEach(e => {
      arr.push({ transaction_number: e });
    })

    /*
    * passing transaction_number so we can get allocated date
    * passing timezone_sql for correct time display
    */
    let reqObj = {
      web_filter: {
        distribution_id: _.get(this.currentFilter["selectedCampaign"], 'distribution_id'),
        transaction_number: _.get(arr[0], 'transaction_number'),
        timezone_sql: this.helper.getUTC()
      },
      data: arr
    };
    this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_DOWNLOAD_FILE", {}));

    this.allocSvc.autoDownload(this.allocationLevel, reqObj).pipe(
      finalize(() => {
        this.loading.allocate = false;
        loadingDialog.close();
        return observableOf(null);
      })
    )
    .subscribe(
      (res: any) => {
        if (environment.showLogs) {
          console.log(res);
        }
        if (_.toLower(_.get(res, 'value')) == "success") {
          this.helper.openDownloadMenu(_.get(res, 'data'));
          this.reloadAndClear();
        }
        else {
          this.dialogService.openSnackBar(this.networkErrMsg);
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  disableAllocation() {
    if(!this.listData.length) {
      return true;
    }
    let disableFlag = true;
    for(let i in this.listData) {
      if(_.has(this.listData[i], 'quantity') && (_.get(this.listData[i], 'quantity') > 0) && (_.get(this.listData[i], 'quantity') != null)) {
        disableFlag = false;
        break;
      }
    }

    for(let i in this.listData) {
      if(_.includes(_.get(this.listData[i], 'quantity'), ".") || (_.has(this.listData[i], 'quantity') && isNaN(_.get(this.listData[i], 'quantity'))) ) {
        disableFlag = true;
        break;
      }
    }
    return disableFlag;
  }

  download() {
    this.downloadTemplate(this.currentFilter);
  }

  // Call download template API
  // In old implementation, excel was generated directly thru UI 
  downloadTemplate(selectedFilters) {
    const loadingDialog = this.dialogService.loading();
    let request;

    if (this.allocationLevel == 'one') {
      request = _.cloneDeep(requestUserAllocationDownload);
      request.web_filter.filters.distribution_id = selectedFilters.selectedCampaign.distribution_id;
      request.web_filter.filters.group_filter_id = _.map(selectedFilters.selectedGroup, val => val.id);
      request.web_filter.full_name = localStorage.getItem("fullname");
    } else {
      request = _.cloneDeep(requestRecipientAllocationDownload);
      request.web_filter.filters.distribution_id = selectedFilters.selectedCampaign.distribution_id;
      request.web_filter.filters.group_filter_id = _.map(selectedFilters.selectedGroup, val => val.id);
      request.web_filter.full_name = localStorage.getItem("fullname");
      
      // Refer to AllocFilterComponent for selectedWebUser value
      if (Array.isArray(selectedFilters.selectedWebUser)) {
        request.web_filter.filters.web_user_id = selectedFilters.selectedWebUser.map(val => val.user_id);
      } else {
        request.web_filter.filters.web_user_id = [selectedFilters.selectedWebUser.user_id];
      }
    }
    
    const moduleFunction = this.allocationLevel == 'one' ? this.allocSvc.downloadTemplateLevelOne(request) : this.allocSvc.downloadTemplateLevelTwo(request);  

    moduleFunction
      .pipe(
        finalize(() => {
          return observableOf(null);
        })
      )
      .subscribe(
        (res: any) => {
          if (environment.showLogs) {
            console.log(res);
          }

          if (!res || res.status == 0 || res.status == 400) {
            this.dialogService.openSnackBar(this.networkErrMsg);
            return;
          } 
          
          if (_.has(res, 'value') && (_.toLower(res.value) == _.toLower("Success"))) {
            if(_.get(res, 'data')) {
              this.helper.openDownloadMenu(res.data);
            }
            else {
              this.helper.downloadThruEmailNotif();
            }
          }
          
          loadingDialog.close();      
        },
        (err) => {
          if (environment.showLogs) {
            console.error(err);
          }
          this.dialogService.openSnackBar(this.networkErrMsg);
          return observableOf(null);
        }
      );
  }

  reloadAndClear(showMsg: boolean = true) {
    this.listData = [];
    this.currentFilter = {};
    this.quantity = [];

    if (showMsg) {
      this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_ALLOC_SUCCESS", {}));
    }

    this.ngOnInit();
  }
}